import React, { createContext, useContext, useState, useMemo } from 'react'

export const toastContext = createContext(null);

export function ToastProvider({ children }) {
    const [message, setMessage] = useState("");
    const [role, setRole] = useState("");
    const [showToast, setShowToast] = useState(false)

    const handleToastData = (message, role) => {
        setMessage(message)
        setRole(role)
        setShowToast(true)
    };

    const handleHideToast = () => {
        setShowToast(false)
    }

    const toastProps = useMemo(() => ({ message, showToast, role, handleHideToast, handleToastData }), []);

    return (
        <toastContext.Provider value={toastProps}>
            {children}
        </toastContext.Provider>
    )
}

export function useToast() {
    return useContext(toastContext);
}